<script setup>
import { reactive, toRefs, watch, onMounted, ref } from "vue";
import { useRouter, onBeforeRouteUpdate, useRoute } from "vue-router";
import YouMeng from "./utils/YouMeng";

const closeDisplay = ref(false);
let isFirstPage = false;
const router = useRouter();
const route = useRoute();
const backButtonLeft = ref(0);

watch(
  // () => route.path,
  () => route,
  (val) => {
    if (val.path === "/" || val.meta.page) {
      closeDisplay.value = false;
    } else {
      closeDisplay.value = true;
    }
  },
  {
    immediate: true,
    deep: true,
  }
);

watch(
  () => router,
  (val) => {
    if (!router.options.history.state.back) {
      isFirstPage = true;
    } else {
      isFirstPage = false;
    }
  },
  {
    immediate: true,
    deep: true,
  }
);

const back = () => {
  if (isFirstPage) {
    router.push({ path: "/" });
  } else {
    router.back();
  }
};

onMounted(() => {
  YouMeng.initYoumengLog(() => {
    const data = { year: "2026" }; //! 参数必须为字符型，不能为纯数字，包括'123'需要改成'123t
    YouMeng.pushRecord(data);
  });

  if (window.location.host === "wxapp.gz-cmc.com") {
    const scriptFile = document.createElement("script");
    scriptFile.setAttribute("type", "text/javascript");
    scriptFile.setAttribute(
      "src",
      "https://s9.cnzz.com/z_stat.php?id=1280066426&web_id=1280066426"
    );
    document.getElementsByTagName("head")[0].appendChild(scriptFile);
  }
  const { clientWidth } = document.body;
  if (clientWidth > 750) {
    backButtonLeft.value = `${(clientWidth - 750) / 2}px`;
  }
});
</script>
<template>
  <div class="roterContainer">
    <router-view v-slot="{ Component, route }">
      <keep-alive>
        <component
          v-if="route.meta.keepAlive"
          :is="Component"
          :key="route.name"
        ></component>
      </keep-alive>
      <component
        v-if="!route.meta.keepAlive"
        :is="Component"
        :key="route.name"
      ></component>
    </router-view>
    <img
      class="back"
      src="@/assets/images/back.png"
      width="50"
      height="50"
      v-show="closeDisplay"
      @click="back"
      :style="{ left: backButtonLeft }"
    />
  </div>
</template>

<style lang="scss" scoped>
.roterContainer {
  position: relative;
}
.back {
  position: fixed;
  left: 0px;
  bottom: 50px;
}
</style>
